/* ABCD CRO — last deal before checkout, sticky mobile add-to-cart, PDP rating,
   honest shipping / payment copy per market, cart size labels.
   Loaded from snippets/olyx-fixes.liquid (after custom.js and olyx-fixes.js). */
(function () {
  'use strict';
  if (window.__olyxCroLoaded) return;
  window.__olyxCroLoaded = true;

  var CFG = window.OlyxFixesConfig || {};
  var PDP = window.OlyxPdpConfig || null;
  var root = document.documentElement;

  function money(cents) {
    return window.OlyxMoney ? window.OlyxMoney.format(cents) : (cents / 100).toFixed(2);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function ss(key, val) {
    try {
      if (val === undefined) return sessionStorage.getItem(key);
      sessionStorage.setItem(key, val);
    } catch (e) { return null; }
  }
  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  if (CFG.hideKlarna) root.classList.add('olyx-no-klarna');
  /* CFG.freeShipping is already in the visitor's currency and rounded up
     (see snippets/olyx-fixes.liquid), e.g. 45 for EUR, 40 for GBP, 50 for USD */
  var FREE_CENTS = Math.round((CFG.freeShipping || 50) * 100);
  var FREE_TEXT = abcdT('free_from', 'Gratis verzending vanaf __AMOUNT__').replace('__AMOUNT__', money(FREE_CENTS));
  /* free-shipping promises that don't match checkout:
       blanket claims  "Free tracked shipping", "Free worldwide shipping (on all orders)"
       stale amounts   "Free shipping over €50", "Free shipping on orders over $50"
     A plain "free shipping" inside a sentence ("Free shipping unlocked") is left alone. */
  var AMT = '[^\\s·•|,]+';
  var RE_FREESHIP = new RegExp(
    'free\\s+(?:' +
      '(?:tracked|worldwide)\\s+shipping(?:\\s+over\\s+' + AMT + ')?(?:\\s+on\\s+(?:all\\s+)?orders(?:\\s+over\\s+' + AMT + ')?)?' +
      '|shipping(?:\\s+over\\s+' + AMT + '(?:\\s+on\\s+(?:all\\s+)?orders)?|\\s+on\\s+(?:all\\s+)?orders(?:\\s+over\\s+' + AMT + ')?)' +
    ')', 'ig');

  /* ------------------------------------------------------------------
   * 1. Copy that must match reality
   *    - "Free tracked shipping (on all orders)" -> "Free shipping over $50"
   *      (shipping is free from the threshold, not on every order)
   *    - Klarna is not offered in some markets (e.g. USA): remove it there
   * ------------------------------------------------------------------ */
  var SEP = /\s*[·•|]\s*/;
  function matchCase(src, repl) {
    if (src === src.toUpperCase()) return repl.toUpperCase();
    if (src.charAt(0) === src.charAt(0).toLowerCase()) return repl.charAt(0).toLowerCase() + repl.slice(1);
    return repl;
  }
  function fixTextNode(node) {
    var t = node.nodeValue;
    if (!t || t.length > 400) return;
    var changed = t;
    var par = node.parentElement;
    // the cart drawer and shipping bars already compute shipping from the real cart
    var shipOk = !(par && par.closest && par.closest('#CartDrawerPro, .OxUp, .OlyxQA__Trust, .OlyxSticky'));
    if (shipOk && changed.toLowerCase().indexOf(FREE_TEXT.toLowerCase()) === -1 && RE_FREESHIP.test(changed)) {
      RE_FREESHIP.lastIndex = 0;
      changed = changed.replace(RE_FREESHIP, function (m) {
        /* leave "free shipping" inside a longer sentence alone ("free shipping unlocked") */
        return matchCase(m, FREE_TEXT);
      });
    }
    RE_FREESHIP.lastIndex = 0;
    /* "<strong>Free tracked shipping</strong> on all orders": once the bold part
       says "Free shipping over €45", the trailing "on all orders" contradicts it */
    if (shipOk && /^\s*on\s+all\s+orders/i.test(changed)) {
      var prev = node.previousSibling;
      if (prev && (prev.textContent || '').toLowerCase().indexOf(FREE_TEXT.toLowerCase()) !== -1) {
        changed = changed.replace(/^\s*on\s+all\s+orders/i, '');
      }
    }
    if (shipOk && /^\s*free shipping\s*$/i.test(changed)) {
      changed = matchCase(changed.trim(), FREE_TEXT);
    }
    if (CFG.hideKlarna && /klarna/i.test(changed)) {
      /* keep the separators at the edges of this text node, so the pieces
         around it (often in other elements) stay separated: "… · Buy 2 …" */
      var hasLead = /^\s*[·•|]/.test(changed);
      var hasTrail = /[·•|]\s*$/.test(changed);
      var parts = changed.split(SEP);
      if (parts.length > 1) {
        var kept = parts.filter(function (p) { return p.trim() && !/klarna/i.test(p); });
        var body = kept.join(' · ');
        if (body) changed = (hasLead ? ' · ' : '') + body + (hasTrail ? ' · ' : '');
        else changed = (hasLead && hasTrail) ? ' · ' : (hasLead || hasTrail ? ' ' : '');
      } else {
        changed = '';
      }
      if (!changed.trim() && !hasLead && !hasTrail) {
        hideKlarnaHolder(node.parentElement);
      }
    }
    if (changed !== t) node.nodeValue = changed;
  }
  function hideKlarnaHolder(el) {
    if (!el) return;
    var holder = el.closest('li, .olyx-announce__slide, [class*="Ticker__Item"], [class*="ticker__item"], [class*="TrustBar__Item"], [class*="trust-bar__item"], [class*="Item"]') || el;
    // never hide big containers
    if (holder.textContent.length < 90) holder.style.display = 'none';
  }
  function fixCopy(scope) {
    if (!scope || !scope.nodeType) return;
    if (scope.nodeType === 3) { fixTextNode(scope); return; }
    if (scope.closest && scope.closest('script,style,.OlyxLD')) return;
    var w = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        if (!p || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/.test(p.nodeName)) return NodeFilter.FILTER_REJECT;
        return /klarna|free\s+(tracked\s+|worldwide\s+)?shipping|^\s*on\s+all\s+orders/i.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var list = [];
    while (w.nextNode()) list.push(w.currentNode);
    list.forEach(fixTextNode);
    if (CFG.hideKlarna) {
      scope.querySelectorAll && scope.querySelectorAll('.OlyxKlarna, .cdp__klarna, [class*="klarna" i]').forEach(function (e) {
        if (!e.closest('.OlyxLD')) e.style.display = 'none';
      });
      // payment icons: <svg><title>Klarna</title></svg> or <img alt="Klarna">
      scope.querySelectorAll && scope.querySelectorAll('svg title, img[alt]').forEach(function (t) {
        var label = t.nodeName.toLowerCase() === 'title' ? t.textContent : t.getAttribute('alt');
        if (/klarna/i.test(label || '')) {
          var icon = t.closest('li') || t.closest('svg') || t;
          icon.style.display = 'none';
        }
      });
    }
  }

  /* ------------------------------------------------------------------
   * 2. Product page
   * ------------------------------------------------------------------ */
  function pdpRating() {
    if (!PDP || document.querySelector('.OlyxRating')) return;
    var title = document.querySelector('.ProductMeta__Title');
    var say = document.getElementById('shopify-section-olyx-say');
    if (!title || !say) return;
    var txt = say.innerText || '';
    var r = txt.match(/([\d.,]+)\s*out of 5/i);
    var c = txt.match(/([\d.,]+)\s*reviews/i);
    if (!r) return;
    var a = document.createElement('a');
    a.className = 'OlyxRating';
    a.href = '#shopify-section-olyx-say';
    a.innerHTML = '<span class="OlyxRating__Stars" aria-hidden="true">★★★★★</span>' +
      '<span class="OlyxRating__Score">' + esc(r[1]) + '</span>' +
      /* these are shop reviews (the "What customers say" block), not reviews of this product */
      (c ? '<span class="OlyxRating__Count">' + esc(c[1]) + ' ' + abcdT('shop_reviews', 'winkelreviews') + '</span>' : '');
    a.addEventListener('click', function (e) {
      e.preventDefault();
      say.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    title.insertAdjacentElement('afterend', a);
  }

  function pdpShippingBar() {
    if (!PDP) return;
    var bar = document.querySelector('.OxUp--pdp');
    if (!bar) return; /* shipping is free on every order */
    var w = document.createTreeWalker(bar, NodeFilter.SHOW_TEXT);
    while (w.nextNode()) {
      var n = w.currentNode;
      if (/more for free shipping/i.test(n.nodeValue || '')) {
        var txt = n.parentElement;
        if (txt.closest('.OxUp__Hl')) txt = txt.closest('.OxUp__Hl').parentElement;
        txt.innerHTML = abcdT('free_ship_item_html', '<strong>Gratis verzending</strong> op dit artikel');
        var fill = bar.querySelector('[class*="Fill"], [class*="fill"]');
        if (fill) { fill.style.width = '100%'; }
        break;
      }
    }
  }

  /* Shipping + returns line under Add to cart (no delivery dates, by request).
     Free-shipping amount is in the visitor currency; 48h note only on
     products tagged for 48h dispatch. */
  function pdpDelivery() {
    if (!PDP || document.querySelector('.OlyxEta')) return;
    var atc = document.querySelector('.ProductForm__AddToCart');
    if (!atc || !atc.parentNode) return;
    var data = {};
    try { data = JSON.parse((document.getElementById('OlyxPdpData') || {}).textContent || '{}'); } catch (e) {}
    var box = document.createElement('div');
    box.className = 'OlyxEta';
    box.innerHTML =
      '<p class="OlyxEta__Row OlyxEta__Row--small">' +
      (data.has48h ? '<span>⚡ ' + abcdT('ships_48h', 'Binnen 48 uur verzonden') + '</span><span aria-hidden="true">·</span>' : '') +
      '<span>' + esc(FREE_TEXT) + '</span><span aria-hidden="true">·</span>' +
      '<a href="' + ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'pages/returns">' + abcdT('returns_14', '14 dagen retourrecht') + '</a></p>';
    atc.parentNode.insertBefore(box, atc.nextSibling);
    /* the separate "Ships within 48 hours" strip above the title is now part of this line */
    var strip = document.querySelector('.OlyxPdp__ShipRow');
    if (strip) strip.style.display = 'none';
  }

  function pdpEmptyReviews() {
    var box = document.getElementById('mf-reviews');
    if (!box) return;
    if (box.querySelector('.jdgm-rev, .jdgm-rev-widg__reviews .jdgm-rev')) {
      box.classList.remove('OlyxHidden');
    } else {
      box.classList.add('OlyxHidden');
    }
  }

  // Sticky add-to-cart bar (phones)
  function stickyAtc() {
    if (!PDP || document.querySelector('.OlyxSticky')) return;
    var atc = document.querySelector('.ProductForm__AddToCart');
    if (!atc || !('IntersectionObserver' in window)) return;
    var bar = document.createElement('div');
    bar.className = 'OlyxSticky';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<img class="OlyxSticky__Img" alt="" src="' + esc(PDP.image) + '">' +
      '<div class="OlyxSticky__Info"><span class="OlyxSticky__Size"></span><span class="OlyxSticky__Price"></span></div>' +
      '<button type="button" class="OlyxSticky__Btn">' + abcdT('add_to_cart', 'In winkelwagen') + '</button>';
    document.body.appendChild(bar);
    var sizeEl = bar.querySelector('.OlyxSticky__Size');
    var priceEl = bar.querySelector('.OlyxSticky__Price');
    function sync() {
      var sel = document.querySelector('.OlyxSizeBtn.is-selected');
      var label = sel ? (sel.getAttribute('data-olyx-label') || sel.textContent) : '';
      if (sel && sel.querySelector('.OlyxSizeSub')) label = sel.firstChild ? sel.firstChild.textContent : label;
      sizeEl.textContent = !sizeChosen ? abcdT('select_size', 'Kies je maat') : (label ? abcdT('size_prefix', 'Maat:') + ' ' + label.trim() : PDP.title);
      var p = document.querySelector('.ProductMeta .OlyxPrice__Sale, .ProductMeta__PriceList .Price:not(.Price--compareAt)');
      priceEl.textContent = p ? p.textContent.trim() : '';
      var disabled = atc.disabled || atc.getAttribute('disabled') !== null;
      bar.querySelector('.OlyxSticky__Btn').textContent = disabled ? abcdT('sold_out', 'Uitverkocht') : (atc.textContent.trim() || abcdT('add_to_cart', 'In winkelwagen'));
    }
    bar.querySelector('.OlyxSticky__Btn').addEventListener('click', function () {
      sync();
      if (!sizeChosen && window.__olyxAskSize) { window.__olyxAskSize(); return; }
      atc.click();
    });
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var below = e.boundingClientRect.top < 0; // scrolled past the real button
      bar.classList.toggle('is-visible', !e.isIntersecting);
      sync();
    }).observe(atc);
    window.addEventListener('click', function () { setTimeout(sync, 50); }, true);
    sync();
  }

  /* Make shoppers pick their size. The theme pre-selects the first size,
     so "Add to cart" (and the sticky bar) could add a size nobody chose. */
  var sizeChosen = /[?&]variant=/.test(location.search);
  function sizeGuard() {
    if (!PDP) return;
    // the theme re-renders the size list, so always look it up again
    function getBox() {
      var l = document.querySelector('.OlyxInline__SizeList');
      return l ? (l.closest('.OlyxInline') || l) : null;
    }
    var list = document.querySelector('.OlyxInline__SizeList');
    if (!list || list.querySelectorAll('.OlyxSizeBtn').length < 2) { sizeChosen = true; return; }
    function mark() {
      var box = getBox();
      if (!box) return;
      if (!box.querySelector('.OlyxNeedSize__Msg')) {
        var note = document.createElement('p');
        note.className = 'OlyxNeedSize__Msg';
        note.textContent = abcdT('please_select_size', 'Kies eerst je maat');
        box.appendChild(note);
      }
      box.classList.toggle('OlyxNoPick', !sizeChosen);
      if (sizeChosen) box.classList.remove('OlyxNeedSize');
    }
    mark();
    window.__olyxMarkSize = mark;
    // window + capture: the theme stops propagation of size clicks at window level
    window.addEventListener('click', function (e) {
      var sb = e.target.closest && e.target.closest('.OlyxSizeBtn');
      if (sb && sb.closest('.OlyxInline__SizeList')) {
        sizeChosen = true;
        setTimeout(mark, 0);
      }
    }, true);
    document.addEventListener('click', function (e) {
      if (sizeChosen) return;
      var a = e.target.closest && e.target.closest('.ProductForm__AddToCart');
      if (!a) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      askSize();
    }, true);
    function askSize() {
      var box = getBox();
      if (!box) return;
      mark();
      box.classList.remove('OlyxNeedSize');
      void box.offsetWidth;
      box.classList.add('OlyxNeedSize');
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    window.__olyxAskSize = askSize;
  }

  // Homepage hero: the image has no headline, so say what ABCD is
  function heroHeadline() {
    var inner = document.querySelector('#shopify-section-hero-banner .HeroBanner__ContentInner');
    if (!inner || inner.querySelector('.OlyxHero')) return;
    if (inner.querySelector('h1, h2, .HeroBanner__Title, .HeroBanner__Heading')) return;
    var box = document.createElement('div');
    box.className = 'OlyxHero';
    box.innerHTML = '<h1 class="OlyxHero__Title">' + esc(CFG.heroTitle || abcdT('hero_title', 'Authentieke sneakers & streetwear')) + '</h1>' +
      '<p class="OlyxHero__Sub">' + esc(CFG.heroSub || abcdT('hero_sub', 'Tot 40% onder de winkelprijs · Binnen 48 uur verzonden')) + '</p>';
    inner.insertBefore(box, inner.firstChild);
    var wrap = inner.closest('.HeroBanner__Content');
    if (wrap) wrap.classList.add('OlyxHero--scrim');
  }

  // Quick add drawer: same rule, the shopper picks the size
  var qaChosen = false;
  window.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-quick-add-open]')) { qaChosen = false; return; }
    if (e.target.closest('.QuickAddDrawer__Option')) {
      qaChosen = true;
      var o = document.querySelector('.QuickAddDrawer__Options');
      if (o) o.classList.remove('OlyxNoPick', 'OlyxNeedSize');
      return;
    }
    var sub = e.target.closest('[data-quick-add-submit]');
    if (!sub || qaChosen) return;
    var opts = document.querySelector('.QuickAddDrawer__Options');
    if (!opts || opts.querySelectorAll('.QuickAddDrawer__Option').length < 2) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    opts.classList.remove('OlyxNeedSize');
    void opts.offsetWidth;
    opts.classList.add('OlyxNeedSize');
    opts.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, true);
  function qaMarkUnpicked() {
    if (qaChosen) return;
    var o = document.querySelector('.QuickAddDrawer__Options');
    if (o && o.querySelectorAll('.QuickAddDrawer__Option').length > 1) o.classList.add('OlyxNoPick');
  }

  /* ------------------------------------------------------------------
   * 3. Cart drawer: size labels that match the product page
   * ------------------------------------------------------------------ */
  var productCache = {};
  function parseSize(raw) {
    var m = String(raw || '').match(/EU\s*([\d.]+)[^/]*\/\s*US\s*M\s*([\d.]+)\s*\/\s*US\s*W\s*([\d.]+)/i);
    return m ? { eu: parseFloat(m[1]), m: parseFloat(m[2]), w: parseFloat(m[3]) } : null;
  }
  function num(n) { return String(Math.round(n * 10) / 10); }
  // same rule as olyx-fixes.js: two EU sizes on one US size -> smaller EU steps down half a size
  function usLabels(raws) {
    var out = {}, used = {}, groups = {};
    raws.forEach(function (r) {
      var p = parseSize(r);
      if (!p) return;
      var t = 'M ' + num(p.m) + ' / W ' + num(p.w);
      out[r] = t; used[t] = true;
      (groups[t] = groups[t] || []).push({ r: r, p: p });
    });
    Object.keys(groups).forEach(function (t) {
      var g = groups[t];
      if (g.length < 2) return;
      g.sort(function (a, b) { return b.p.eu - a.p.eu; });
      var clash = false;
      for (var i = 1; i < g.length; i++) {
        var cand = 'M ' + num(g[i].p.m - 0.5 * i) + ' / W ' + num(g[i].p.w - 0.5 * i);
        if (!used[cand]) { used[cand] = true; out[g[i].r] = cand; g[i].done = true; } else clash = true;
      }
      if (clash) g.forEach(function (x) { if (!x.done) out[x.r] = t + ' (EU ' + num(x.p.eu) + ')'; });
    });
    return out;
  }
  var cartLabelBusy = false;
  function fixCartLabels() {
    if (!root.classList.contains('olyx-sizes-us') || cartLabelBusy) return;
    var nodes = document.querySelectorAll('#CartDrawerPro .cdp__item');
    if (!nodes.length) return;
    cartLabelBusy = true;
    getJSON('/cart.js').then(function (cart) {
      return Promise.all(cart.items.map(function (it) {
        if (productCache[it.handle]) return productCache[it.handle];
        productCache[it.handle] = getJSON('/products/' + it.handle + '.js').catch(function () { return null; });
        return productCache[it.handle];
      })).then(function (products) {
        var nodesNow = document.querySelectorAll('#CartDrawerPro .cdp__item');
        cart.items.forEach(function (it, i) {
          var node = nodesNow[i];
          var prod = products[i];
          if (!node || !prod) return;
          var vEl = node.querySelector('.cdp__item-variant');
          if (!vEl) return;
          var raws = prod.variants.map(function (v) { return v.title; });
          var map = usLabels(raws);
          var label = map[it.variant_title];
          if (label && vEl.textContent.trim() !== label) vEl.textContent = label;
        });
      });
    }).catch(function () {}).then(function () { cartLabelBusy = false; });
  }

  /* ------------------------------------------------------------------
   * 4. Last deal before checkout
   *    Shown once per session when someone taps Checkout with 1–2 items.
   *    The offer is the existing automatic bundle discount
   *    (2 items = 5% off everything, 3+ = 10%), so nothing new to set up.
   * ------------------------------------------------------------------ */
  var TIER2 = CFG.tier2 || 5, TIER3 = CFG.tier3 || 10;
  var CHECKOUT_SEL = '[data-cdp-checkout], button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href^="/checkout?"]';
  var bypass = false;
  var ld = null; // modal element
  var lastTrigger = null;

  document.addEventListener('click', function (e) {
    if (bypass) return;
    var t = e.target.closest && e.target.closest(CHECKOUT_SEL);
    if (!t || ss('olyxLastDeal') === 'done') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    lastTrigger = t;
    openLastDeal();
  }, true);

  function proceed() {
    ss('olyxLastDeal', 'done');
    closeLD(true);
    var t = lastTrigger;
    bypass = true;
    if (t && document.body.contains(t)) {
      t.click();
      // if the theme did nothing (e.g. cart page form), fall back
      setTimeout(function () { if (location.pathname.indexOf('/checkout') !== 0) location.href = '/checkout'; }, 4000);
    } else {
      location.href = '/checkout';
    }
    setTimeout(function () { bypass = false; }, 2000);
  }

  function pctFor(count) { return count >= 3 ? TIER3 : count === 2 ? TIER2 : 0; }

  function loadDeals(cart) {
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = true; });
    var first = cart.items[0];
    function parse(html) {
      var div = document.createElement('div');
      div.innerHTML = html;
      var s = div.querySelector('script[data-olyx-lastdeal]');
      try { return s ? JSON.parse(s.textContent) : []; } catch (e) { return []; }
    }
    var KIDS = /\((TD|PS|GS)\)|\b(toddler|kids?|baby|infant|bébé)\b/i;
    var cartIsKids = cart.items.some(function (i) { return KIDS.test(i.product_title); });
    function clean(list) {
      return list.filter(function (p) {
        if (inCart[p.id]) return false;
        if (!cartIsKids && KIDS.test(p.title)) return false;
        p.variants = p.variants.filter(function (v) { return !/OLX-|^Variant(\s\d+)?$/i.test(v.title); });
        p.variants.sort(function (a, b) {
          var x = parseSize(p.sizePos ? a['o' + p.sizePos] : a.title), y = parseSize(p.sizePos ? b['o' + p.sizePos] : b.title);
          return x && y ? x.eu - y.eu : 0;
        });
        return p.variants.length > 0;
      });
    }
    var recUrl = '/recommendations/products?product_id=' + first.product_id + '&limit=10&intent=related&section_id=olyx-lastdeal';
    return fetch(recUrl).then(function (r) { return r.text(); }).then(function (h) {
      var list = clean(parse(h));
      if (list.length >= 3) return list;
      return fetch('/collections/all?sort_by=best-selling&section_id=olyx-lastdeal').then(function (r) { return r.text(); })
        .then(function (h2) { return list.concat(clean(parse(h2))); });
    }).then(function (list) {
      // cheapest first: a small add-on is the easiest yes
      var seen = {};
      list = list.filter(function (p) { if (seen[p.id]) return false; seen[p.id] = 1; return true; });
      list.sort(function (a, b) { return a.price - b.price; });
      return list.slice(0, 3);
    });
  }

  function sizeOptionLabel(p, v) {
    var val = p.sizePos ? v['o' + p.sizePos] : v.title;
    if (root.classList.contains('olyx-sizes-us') && parseSize(val)) {
      var map = usLabels(p.variants.map(function (x) { return p.sizePos ? x['o' + p.sizePos] : x.title; }));
      var lab = map[val] || val;
      return p.variants.length && v.title !== val ? v.title.replace(val, lab) : lab;
    }
    return v.title;
  }

  function renderLD(cart, deals) {
    var count = cart.item_count;
    var nextPct = pctFor(count + 1);
    var nowPct = pctFor(count);
    var headline = nextPct > nowPct
      ? abcdT('ld_head_more_html', 'Wacht even: voeg nog 1 artikel toe en krijg <em>__PCT__% korting op alles</em>').replace('__PCT__', nextPct)
      : abcdT('ld_head_complete', 'Maak je bestelling compleet');
    var sub = nextPct > nowPct
      ? abcdT('ld_sub_bundle', 'Je bundelkorting wordt automatisch verrekend bij het afrekenen, op je hele bestelling en niet alleen op het nieuwe artikel.')
      : abcdT('ld_sub_popular', 'Populaire keuzes die passen bij je bestelling.');
    // pre-select the shoe size the shopper already chose (same EU size)
    var cartEu = null;
    cart.items.some(function (i) { var ps = parseSize(i.variant_title); if (ps) { cartEu = ps.eu; return true; } return false; });
    var items = deals.map(function (p, idx) {
      var opts = p.variants.map(function (v) {
        var ps = parseSize(p.sizePos ? v['o' + p.sizePos] : v.title);
        var sel = cartEu !== null && ps && ps.eu === cartEu ? ' selected' : '';
        return '<option value="' + v.id + '"' + sel + '>' + esc(sizeOptionLabel(p, v)) + '</option>';
      }).join('');
      var single = p.variants.length === 1;
      var saveCents = Math.round((cart.original_total_price + p.price) * nextPct / 100) - Math.round(cart.original_total_price * nowPct / 100);
      return '<li class="OlyxLD__Item" data-idx="' + idx + '">' +
        '<a class="OlyxLD__Img" href="' + esc(p.url) + '"><img src="' + esc(p.image) + '" alt="" loading="lazy"></a>' +
        '<div class="OlyxLD__Body">' +
          '<a class="OlyxLD__Title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<div class="OlyxLD__Price"><span>' + esc(p.priceText) + '</span>' + (p.compare ? '<s>' + esc(p.compare) + '</s>' : '') + '</div>' +
          (nextPct > nowPct && saveCents > 0 ? '<div class="OlyxLD__Save">' + esc(abcdT('ld_unlocks', 'Levert __AMOUNT__ korting op je bestelling op').replace('__AMOUNT__', money(saveCents))) + '</div>' : '') +
          '<div class="OlyxLD__Row">' +
            (single ? '<input type="hidden" value="' + p.variants[0].id + '">' :
              '<select class="OlyxLD__Select" aria-label="' + abcdT('select_size', 'Kies je maat') + '"><option value="">' + abcdT('size_placeholder', 'Kies maat') + '</option>' + opts + '</select>') +
            '<button type="button" class="OlyxLD__Add">' + abcdT('add', 'Toevoegen') + '</button>' +
          '</div>' +
        '</div>' +
      '</li>';
    }).join('');

    ld = document.createElement('div');
    ld.className = 'OlyxLD';
    ld.setAttribute('role', 'dialog');
    ld.setAttribute('aria-modal', 'true');
    ld.setAttribute('aria-label', abcdT('ld_tag', 'Laatste deal voor het afrekenen'));
    ld.innerHTML =
      '<div class="OlyxLD__Backdrop" data-ld-close></div>' +
      '<div class="OlyxLD__Panel">' +
        '<button type="button" class="OlyxLD__Close" aria-label="' + abcdT('close', 'Sluiten') + '" data-ld-close>&times;</button>' +
        '<span class="OlyxLD__Tag">' + abcdT('ld_tag', 'Laatste deal voor het afrekenen') + '</span>' +
        '<h2 class="OlyxLD__Head">' + headline + '</h2>' +
        '<p class="OlyxLD__Sub">' + sub + '</p>' +
        (nextPct > nowPct ? '<div class="OlyxLD__Tiers">' +
          '<span class="' + (count === 1 ? 'is-now' : '') + '">' + abcdT('tier1_html', '1 artikel<br><b>standaard</b>') + '</span>' +
          '<span class="' + (count === 2 ? 'is-now' : (count + 1 === 2 ? 'is-next' : '')) + '">' + abcdT('tier2_html', '2 artikelen<br><b>__PCT__% korting</b>').replace('__PCT__', TIER2) + '</span>' +
          '<span class="' + (count + 1 >= 3 ? 'is-next' : '') + '">' + abcdT('tier3_html', '3+ artikelen<br><b>__PCT__% korting</b>').replace('__PCT__', TIER3) + '</span>' +
        '</div>' : '') +
        '<ul class="OlyxLD__List">' + items + '</ul>' +
        '<div class="OlyxLD__Foot">' +
          '<button type="button" class="OlyxLD__Go">' + abcdT('continue_checkout', 'Doorgaan naar afrekenen') + '</button>' +
          '<button type="button" class="OlyxLD__Skip">' + abcdT('no_thanks', 'Nee, bedankt') + '</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(ld);
    root.classList.add('OlyxLD-open');
    requestAnimationFrame(function () { ld.classList.add('is-open'); });
    fixCopy(ld);

    ld.addEventListener('click', function (e) {
      if (e.target.closest('[data-ld-close]')) { ss('olyxLastDeal', 'done'); closeLD(false); return; }
      if (e.target.closest('.OlyxLD__Go') || e.target.closest('.OlyxLD__Skip')) { proceed(); return; }
      var add = e.target.closest('.OlyxLD__Add');
      if (add) addDeal(add, cart, deals);
    });
    document.addEventListener('keydown', escClose);
    var go = ld.querySelector('.OlyxLD__Go');
    if (go) go.focus({ preventScroll: true });
  }
  function escClose(e) { if (e.key === 'Escape' && ld) { ss('olyxLastDeal', 'done'); closeLD(false); } }

  function addDeal(btn, cart, deals) {
    var li = btn.closest('.OlyxLD__Item');
    var input = li.querySelector('select, input[type=hidden]');
    var id = input && input.value;
    if (!id) {
      li.classList.add('needs-size');
      if (input && input.focus) input.focus();
      return;
    }
    li.classList.remove('needs-size');
    btn.disabled = true;
    btn.textContent = abcdT('adding', 'Toevoegen…');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return getJSON('/cart.js');
    }).then(function (c) {
      btn.textContent = abcdT('added_check', 'Toegevoegd ✓');
      li.classList.add('is-added');
      var pct = pctFor(c.item_count);
      var head = ld.querySelector('.OlyxLD__Head');
      var go = ld.querySelector('.OlyxLD__Go');
      if (pct) {
        var save = Math.round(c.original_total_price * pct / 100);
        head.innerHTML = abcdT('ld_unlocked_html', 'Top: <em>__PCT__% korting op alles</em> vrijgespeeld').replace('__PCT__', pct);
        go.textContent = abcdT('checkout_save', 'Afrekenen en __AMOUNT__ besparen').replace('__AMOUNT__', money(save));
        var sub = ld.querySelector('.OlyxLD__Sub');
        if (sub) sub.textContent = abcdT('discount_auto', 'De korting wordt automatisch verrekend bij het afrekenen.');
      } else {
        go.textContent = abcdT('continue_checkout', 'Doorgaan naar afrekenen');
      }
      ld.querySelector('.OlyxLD__Skip').style.display = 'none';
      ld.querySelectorAll('.OlyxLD__Tiers span').forEach(function (s, i) {
        s.classList.toggle('is-now', (i === 0 && c.item_count === 1) || (i === 1 && c.item_count === 2) || (i === 2 && c.item_count >= 3));
        s.classList.remove('is-next');
      });
      var nPct = pctFor(c.item_count + 1);
      ld.querySelectorAll('.OlyxLD__Item').forEach(function (row) {
        if (row.classList.contains('is-added')) return;
        var sv = row.querySelector('.OlyxLD__Save');
        var d = deals[Number(row.getAttribute('data-idx'))];
        var extra = d ? Math.round((c.original_total_price + d.price) * nPct / 100) - Math.round(c.original_total_price * pct / 100) : 0;
        if (sv) {
          if (nPct > pct && extra > 0) sv.textContent = abcdT('ld_add_too', 'Voeg dit ook toe: __PCT__% korting op alles (__AMOUNT__ extra korting)').replace('__PCT__', nPct).replace('__AMOUNT__', money(extra));
          else sv.remove();
        }
      });
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = abcdT('try_again', 'Probeer opnieuw');
    });
  }

  function closeLD(goingToCheckout) {
    if (!ld) return;
    var el = ld;
    ld = null;
    el.classList.remove('is-open');
    root.classList.remove('OlyxLD-open');
    document.removeEventListener('keydown', escClose);
    setTimeout(function () { el.remove(); }, 250);
    if (!goingToCheckout && el.querySelector('.is-added') && typeof window.cdpOpenCart === 'function') {
      try { window.cdpOpenCart(); } catch (e) {}
    }
  }

  function openLastDeal() {
    getJSON('/cart.js').then(function (cart) {
      if (!cart.item_count || cart.item_count >= 3) { proceed(); return; }
      return loadDeals(cart).then(function (deals) {
        if (!deals.length) { proceed(); return; }
        renderLD(cart, deals);
      });
    }).catch(function () { proceed(); });
  }

  /* ------------------------------------------------------------------
   * Boot
   * ------------------------------------------------------------------ */
  var pending = false;
  var dirty = [];
  var cartDirty = false;
  function flush() {
    pending = false;
    var list = dirty; dirty = [];
    list.forEach(function (n) { if (n.isConnected !== false) fixCopy(n); });
    pdpShippingBar();
    pdpDelivery();
    qaMarkUnpicked();
    if (window.__olyxMarkSize) window.__olyxMarkSize();
    if (cartDirty) { cartDirty = false; fixCartLabels(); }
  }
  function start() {
    fixCopy(document.body);
    pdpRating();
    pdpShippingBar();
    pdpDelivery();
    sizeGuard();
    stickyAtc();
    heroHeadline();
    fixCartLabels();
    setTimeout(pdpEmptyReviews, 2500);
    setTimeout(pdpEmptyReviews, 6000);
    setTimeout(function () { pdpRating(); fixCopy(document.body); }, 1500);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        var el = m.target && (m.target.nodeType === 1 ? m.target : m.target.parentElement);
        if (!el || el.closest('.OlyxLD')) return;
        if (el.closest('#CartDrawerPro')) cartDirty = true;
        if (m.type === 'characterData') dirty.push(m.target);
        else m.addedNodes.forEach(function (n) { if (n.nodeType === 1 || n.nodeType === 3) dirty.push(n); });
      });
      if (!pending && dirty.length) { pending = true; setTimeout(flush, 60); }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ------------------------------------------------------------------
 * Product cards: colour dots never run under the quick-add bag button.
 * The dots stay on one row: as many as fit the card's width, then a
 * "+N" bubble that opens the product. Cards added later (filters,
 * infinite scroll) and screen-size changes are handled too.
 * ------------------------------------------------------------------ */
(function () {
  'use strict';
  var DOT = 22, GAP = 4, BUBBLE = 26, RESERVED = 38; /* RESERVED = padding-right kept for the bag button (olyx-cro.css) */
  function decorate(list) {
    var labels = list.querySelectorAll('label.ColorSwatch');
    var more = list.querySelector('.OlyxSwMore');
    var width = list.clientWidth - RESERVED;
    var max;
    if (width <= 0) {
      max = window.innerWidth < 750 ? 3 : 6;
    } else {
      var fitAll = Math.floor((width + GAP) / (DOT + GAP));
      max = labels.length <= fitAll ? labels.length : Math.max(1, Math.floor((width + GAP - BUBBLE - GAP) / (DOT + GAP)));
    }
    var hidden = 0;
    for (var i = 0; i < labels.length; i++) {
      var hide = i >= max && !labels[i].classList.contains('is-selected');
      labels[i].classList.toggle('OlyxSwHidden', hide);
      if (hide) hidden++;
    }
    if (hidden > 0) {
      if (!more) {
        var card = list.closest('.ProductItem, [data-product-item]');
        var link = card && card.querySelector('a[href*="/products/"]');
        more = document.createElement('a');
        more.className = 'OlyxSwMore';
        more.href = link ? link.getAttribute('href') : '#';
        list.appendChild(more);
      }
      more.textContent = '+' + hidden;
      more.setAttribute('aria-label', abcdT('more_colours', 'nog __N__ kleuren').replace('__N__', hidden));
    } else if (more) {
      more.parentNode.removeChild(more);
    }
    list.setAttribute('data-olyx-sw', String(list.clientWidth));
  }
  function scan(all) {
    var lists = document.querySelectorAll('.ProductItem__ColorSwatchList');
    for (var i = 0; i < lists.length; i++) {
      if (all || lists[i].getAttribute('data-olyx-sw') !== String(lists[i].clientWidth)) decorate(lists[i]);
    }
  }
  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; scan(false); }, 80);
  }
  function start() {
    scan(true);
    if (window.MutationObserver) {
      new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
    }
    window.addEventListener('resize', queue, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
